export default __webpack_public_path__ + "static/media/mostra-4.53643c68.png";